<div class="uc-dialog">
  <div class="uc-content">
    <h2 class="uc-title">¿Estás seguro?</h2>
    <p class="uc-message">
      Si cierras, los datos de tu cobro<br>
      no quedarán guardados.
    </p>
  </div>
  
  <footer class="uc-footer">
    <button type="button" (click)="close.emit()" class="uc-button uc-button-secondary">
      Cerrar
    </button>
    <button type="button" (click)="saveAndClose.emit()" class="uc-button uc-button-primary">
      Guardar y cerrar
    </button>
  </footer>
</div>